import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';

import { MetricCard } from '../tool-content.model';

/**
 * Renders a horizontal row of metric stat cards inline within a chat message.
 */
@Component({
  selector: 'app-ai-metrics',
  templateUrl: './ai-metrics.component.html',
  styleUrls: ['./ai-metrics.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AiMetricsComponent {
  readonly metrics = input.required<MetricCard[]>();

  protected readonly hasMetrics = computed(() => this.metrics().length > 0);

  protected trendIcon(trend?: 'up' | 'down' | 'flat'): string {
    switch (trend) {
      case 'up':
        return '↑';
      case 'down':
        return '↓';
      case 'flat':
        return '→';
      default:
        return '';
    }
  }
}
